const SWITCH_COMPLETED_LIST = 'SWITCH_COMPLETED_LIST';
const SWITCH_IMPORTANT_LIST = 'SWITCH_IMPORTANT_LIST';
const SWITCH_ALL_TASKS = 'SWITCH_ALL_TASKS';
const SELECT_ACTIVE_LIST = 'SELECT_ACTIVE_LIST';
const SEARCH_TODOS = 'SEARCH_TODOS';
const TOGGLE_RENAMING_LIST = 'TOGGLE_RENAMING_LIST';
const TOGGLE_DELETING_LIST = 'TOGGLE_DELETING_LIST';
const TOGGLE_CREATING_LIST = 'TOGGLE_CREATING_LIST';
const TOGGLE_CREATING_TODO = 'TOGGLE_CREATING_TODO';

export {
	SWITCH_COMPLETED_LIST,
	SWITCH_IMPORTANT_LIST,
	SWITCH_ALL_TASKS,
	SELECT_ACTIVE_LIST,
	SEARCH_TODOS,
	TOGGLE_RENAMING_LIST,
	TOGGLE_DELETING_LIST,
	TOGGLE_CREATING_LIST,
	TOGGLE_CREATING_TODO
}